import { render, staticRenderFns } from "./award-result.vue?vue&type=template&id=40c6f982&"
import script from "./award-result.vue?vue&type=script&lang=js&"
export * from "./award-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports